<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div class="col-xs-12 mycol">
      <table class="co-executor">
        <thead>
          <tr>
            <td style="width: 40%">Вид обеспечения</td>
            <td style="width: 25%">
              Юридическое или физическое лицо, предоставляющее обеспечение
            </td>
            <td style="width: 10%">Объем обеспечения, тыс. руб.</td>
            <td style="width: 25%">Комментарий</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in covers">
            <td>
              <span v-if="!item.isu">{{ item.name }}</span>
              <select
                v-if="item.isz"
                disabled
                class="sel-dropdown i-main-style"
              >
                <option selected>{{ item.zname }}</option>
              </select>
              <NumericField
                separator="space"
                v-if="item.iso"
                disabled
                :value="item.zname"
                class="sel-dropdown i-main-style"
                style="width: 300px"
              />
            </td>
            <td>
              <NumericField
                separator="space"
                type="text"
                style="width: 90%"
                class="i-main-style i-co-executor-style"
                v-model="item.UF_JUR_FACE"
                :disabled="$parent.$parent.projectDisabled"
              />
            </td>
            <td>
              <NumericField
                separator="space"
                type="text"
                class="i-main-style"
                v-model="item.UF_OBJEM_VALUE"
                :disabled="$parent.$parent.projectDisabled"
              />
            </td>
            <td>
              <NumericField
                separator="space"
                type="text"
                style="width: 100%"
                class="i-main-style i-co-executor-style"
                v-model="item.UF_COMMENT"
                :disabled="$parent.$parent.projectDisabled"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { FETCH_DIRECTORY } from "@/store/actions.type";
import { mapGetters } from "vuex";
import NumericField from "@/components/NumericField";
export default {
  name: "CashBack",
  components: { NumericField },
  data() {
    return {
      covers: []
    };
  },
  async created() {
    await this.$store.dispatch(FETCH_DIRECTORY, ["vid_procuring"]);
    await this.$store.dispatch(FETCH_DIRECTORY, ["vid_zalog"]);
    this.project.COVER_OLD.COVER_ID.forEach(function(cover) {
      this.directory.vid_procuring.forEach(function(c) {
        if (c.ID === cover) {
          if (!this.project.COVER_OLD.items[cover]) {
            if (c.CODE === "user") {
              this.covers.push({
                zname: "",
                isu: 1,
                iso: 1,
                name: c.NAME,
                UF_JUR_FACE: "",
                UF_OBJEM_VALUE: "",
                UF_COMMENT: ""
              });
            } else {
              this.covers.push({
                name: c.NAME,
                UF_JUR_FACE: "",
                UF_OBJEM_VALUE: "",
                UF_COMMENT: ""
              });
            }
          } else {
            this.project.COVER_OLD.items[cover].forEach(function(e) {
              if (c.CODE === "zalog") {
                if (e.UF_VID_ZALOG) {
                  this.directory.vid_procuring.forEach(function(z) {
                    if (z.ID === e.UF_VID_ZALOG) {
                      this.covers.push({
                        name: c.NAME,
                        zname: z.UF_NAME,
                        isz: 1,
                        UF_JUR_FACE: e.UF_JUR_FACE,
                        UF_OBJEM_VALUE: e.UF_OBJEM_VALUE,
                        UF_COMMENT: e.UF_COMMENT
                      });
                    }
                  }, this);
                } else {
                  this.covers.push({
                    name: c.NAME,
                    zname: e.UF_NAME,
                    isz: 1,
                    UF_JUR_FACE: e.UF_JUR_FACE,
                    UF_OBJEM_VALUE: e.UF_OBJEM_VALUE,
                    UF_COMMENT: e.UF_COMMENT
                  });
                }
              } else if (c.CODE === "other") {
                this.covers.push({
                  name: c.NAME,
                  zname: e.UF_NAME,
                  iso: 1,
                  UF_JUR_FACE: e.UF_JUR_FACE,
                  UF_OBJEM_VALUE: e.UF_OBJEM_VALUE,
                  UF_COMMENT: e.UF_COMMENT
                });
              } else if (c.CODE === "user") {
                this.covers.push({
                  name: c.NAME,
                  zname: e.UF_NAME,
                  isu: 1,
                  iso: 1,
                  UF_JUR_FACE: e.UF_JUR_FACE,
                  UF_OBJEM_VALUE: e.UF_OBJEM_VALUE,
                  UF_COMMENT: e.UF_COMMENT
                });
              } else {
                this.covers.push({
                  name: c.NAME,
                  UF_JUR_FACE: e.UF_JUR_FACE,
                  UF_OBJEM_VALUE: e.UF_OBJEM_VALUE,
                  UF_COMMENT: e.UF_COMMENT
                });
              }
            }, this);
          }
        }
      }, this);
    }, this);
  },
  computed: {
    ...mapGetters(["directory", "project"])
  }
};
</script>

<style scoped></style>
